export default "__VITE_ASSET__B78Yd9D0__"